import { Frame } from '@shared/Frame';
import { ScheduledScreen } from '@shared/types';
import { Component, Fragment, h, State } from '@stencil/core';
// import { fetchEvents } from '../events/EventsService';
import { pollSchedule } from './ScheduleService';
import { ScreenRenderers } from './ScreenRegistry';

@Component({
  tag: 'chapel-screens',
  styleUrl: 'chapel-screens.scss'
})
export class ChapelScreens {

  @State() current: ScheduledScreen;

  private stopPolling?: () => void;

  componentWillLoad(): void {

    // fetchEvents().then(data => {
    //   console.warn({ data });
    // });

    this.stopPolling = pollSchedule(current => {
      this.current = current;

      if (this.current?.action === 'reload') {
        setTimeout(() => location.reload(), 1000);
      }
    })
  }

  disconnectedCallback(): void {
    this.stopPolling();
  }

  render() {
    const { hash } = window.location;
    const action = this.current?.action;
    const renderer = ScreenRenderers[action];
    return (
      <Fragment>
        <Frame>{renderer?.(this.current)}</Frame>
        <div class="fixed flush--right flush--bottom version">
          {action && <span>{action}</span>}
          {hash && <span>{hash}</span>}
          <span>v1.0.57</span>
        </div>
      </Fragment>
    );
  }

}
